<template>
	<BaseCmsPage @load="onPageLoad">
		<CmsCheckoutWrapper>
			<WebshopCheckout step="login" v-slot="{onContinueAsGuest, onLoginApi, urls}">
				<ClientOnly>
					<div class="wc-login">
						<div class="wc-login-box">
							<div class="wc-login-row wc-login-row1">
								<h1 class="wc-title"><BaseCmsLabel code="already_register" /></h1>
								<BaseCmsLabel code="login_to_buy" class="wc-info" tag="div" />
								<button @click="onLoginApi" class="btn btn-green btn-icon-arrow">
									<span><BaseCmsLabel code="login_to_buy_button" /></span>
								</button>
							</div>
							<div class="wc-login-row wc-login-row2">
								<div class="wc-title"><BaseCmsLabel code="guest_checkout" /></div>
								<BaseCmsLabel code="guest_checkout_info" tag="div" class="wc-info" />
								<button class="btn btn-green btn-icon-arrow" @click="onContinueAsGuest">
									<span><BaseCmsLabel code="continue_without_signup" /></span>
								</button>
							</div>
							<BaseCmsLabel v-if="labels.get('checkout_login_note')" code="checkout_login_note" tag="div" class="wc-login-note" />
						</div>
						<div v-if="labels.get('checkout_login_back')" class="wc-login-row wc-login-row-back">
							<NuxtLink :to="urls.webshop_shopping_cart" class="wc-login-btn-back">
								<span><BaseCmsLabel code="checkout_login_back" /></span>
							</NuxtLink>
						</div>
					</div>
					<template #fallback>
						<BaseThemeUiLoading />
					</template>
				</ClientOnly>
			</WebshopCheckout>
		</CmsCheckoutWrapper>
	</BaseCmsPage>
</template>

<script setup>
	const webshop = useWebshop();
	const apiRoutes = useApiRoutes();
	const labels = useLabels();
	const gtm = useGtmBB();
	const { getAppUrl } = useApiRoutes();

	const handleBackButton = () => {
		return navigateTo(getAppUrl('webshop_shopping_cart'))
	};

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}

	onMounted(async () => {
		window.addEventListener('popstate', handleBackButton);
	});

	onBeforeUnmount(() => {
		window.removeEventListener('popstate', handleBackButton);
	});
</script>

<style lang="less" scoped>
	.wc-login{
		flex-shrink: 0; width: 640px; margin: 35px auto;

		@media (max-width: @m){width: auto; margin: 0;}
	}
	.wc-login-box{
		width: 100%; border: 1px solid @borderColor; box-shadow: 0 0 33px 0 rgba(120,145,169,0.23);

		@media (max-width: @m){box-shadow: none; border: 0; border-bottom: 1px solid @borderColor;}
	}
	.wc-login-row{
		padding: 40px 60px; border-bottom: 1px solid @borderColor;

		@media (max-width: @m){padding: 20px 15px 25px 15px;}
	}
	.wc-login-note{
		padding: 30px 60px; font-size: 14px; line-height: 1.4; color: @inputTextColor;

		@media (max-width: @m){padding: 17px 20px 10px;}
	}
	.wc-login-row-back{
		padding: 35px 0 0; border: none;

		@media (max-width: @m){padding: 20px 15px 0;}
	}
	.wc-login-btn-back{
		font-size: 15px; font-weight: 600; color: @blue; text-decoration: none;
		span{
			padding-left: 15px; position: relative;
			&:before{.icon-arrow-down(); font: 10px/10px @fonti; color: @blue; position: absolute; top: 6px; left: 0; .rotate(90deg); .transition(left);}
		}
		&:hover{
			text-decoration: none;
			span:before{left: -5px;}
		}
	}
	.btn{
		min-width: 220px;
		@media (max-width: @m){
			height: 50px; width: 100%; font-size: 16px;
			span:before{top: 7px;}
		}
	}
</style>
